import { IUser } from '@/models';
import { DateTime } from 'luxon';

export const getUserFullName = (user: IUser): string => {
    const fio = user !== null && user !== undefined ? `${user.last_name || ''} ${user.first_name || ''} ${user.middle_name || ''}` : ''
    return fio !== '' ? fio : user && user.hasOwnProperty('email') ? user.email : ''
}
export const getDate = (date: string) => {
    return DateTime.fromISO(date).toFormat('ff');
  }